module.exports = __webpack_public_path__ + "static/media/forgot-username.e8aeede1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/forgot-username.jpg
// module id = 448
// module chunks = 0